import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import image1 from "../../assets/reparateur-velo.png";

const IntroPartenairesSection = () => {
  const { t } = useTranslation("partenaires/IntroSection");

  return (
    <Box sx={{ display: "flex", justifyContent: "center", px: 2, mt: 10 }}>
      <Box
        sx={{
          maxWidth: "1200px",
          width: "100%",
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        {/* Titre */}
        <Typography
          sx={{
            fontWeight: 900,
            fontSize: { xs: "2rem", md: "3rem" },
            color: "#000",
            textAlign: "left",
            mb: 4,
          }}
        >
          {t("title.part1")}{" "}
          <Box component="span" sx={{ color: "#449F2D" }}>
            {t("title.highlight")}
          </Box>
        </Typography>

        {/* Image + texte */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "flex-start",
            gap: 4,
          }}
        >
          {/* Image à gauche */}
          <Box
            sx={{
              width: "160px",
              flexShrink: 0,
              display: { xs: "none", md: "block" },
              mt: "4px",
            }}
          >
            <Box
              component="img"
              src={image1}
              alt={t("imageAlt")}
              sx={{
                width: "100%",
                height: "auto",
                display: "block",
              }}
            />
          </Box>

          {/* Texte à droite */}
          <Box sx={{ flex: 1 }}>
            <Typography
              sx={{
                fontSize: "1.2rem",
                fontWeight: 400,
                color: "#444",
                textAlign: "left",
                mb: 2,
                lineHeight: 1.8,
              }}
            >
              {t("p1.a")}{" "}
              <Box component="span" fontWeight="bold">
                {t("p1.brand")}
              </Box>
              {t("p1.b")}{" "}
              <Box component="span" fontWeight="bold">
                {t("p1.localPartners")}
              </Box>{" "}
              {t("p1.c")}{" "}
              <Box component="span" fontWeight="bold">
                {t("p1.fast")}
              </Box>
              ,{" "}
              <Box component="span" fontWeight="bold">
                {t("p1.reliable")}
              </Box>{" "}
              {t("p1.and")}{" "}
              <Box component="span" fontWeight="bold">
                {t("p1.nearby")}
              </Box>
              . {t("p1.d")}{" "}
              <Box component="span" fontWeight="bold">
                {t("p1.sustainableMobility")}
              </Box>
              . {t("p1.e")}
            </Typography>

            <Typography
              sx={{
                fontSize: "1.1rem",
                fontWeight: 400,
                color: "#444",
                textAlign: "left",
                lineHeight: 1.7,
              }}
            >
              {t("p2.a")}{" "}
              <Box component="span" fontWeight="bold">
                {t("p2.committedActor")}
              </Box>{" "}
              {t("p2.b")} {t("p2.c")}{" "}
              <Box component="span" fontWeight="bold">
                {t("p2.visibility")}
              </Box>{" "}
              {t("p2.d")} {t("p2.e")}{" "}
              <Box component="span" fontWeight="bold">
                {t("p2.localAnchoring")}
              </Box>{" "}
              {t("p2.f")}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default IntroPartenairesSection;